export default __webpack_public_path__ + "static/media/CPR 072204 body.e16db57c.jpg";